import { render } from "./AppLabelInput.vue?vue&type=template&id=d51da37e&scoped=true&ts=true"
import script from "./AppLabelInput.vue?vue&type=script&lang=ts"
export * from "./AppLabelInput.vue?vue&type=script&lang=ts"

import "./AppLabelInput.vue?vue&type=style&index=0&id=d51da37e&scoped=true&lang=sass"

import exportComponent from "/home/casedrive/releases/front/108/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d51da37e"]])

export default __exports__